const Joi = require("joi");
const ValidationTranslateFile = require("../../src/config/ValidationTranslateFile.jsx");
const currentLang = ValidationTranslateFile()

const findInmatesSchema = (data) => {
  const schema = Joi.object({
    relationship: Joi.string()
      .trim()

      .required()
      .messages({
        "any.required": currentLang?.ValidationSchema?.Please_Enter_Relationship,
        "string.empty": currentLang?.ValidationSchema?.Please_Enter_Relationship,
      }),
  }).unknown(true); // Allow unknown keys in the object (useful if you're validating only part of the data)

  return schema.validate(data, { abortEarly: false });
};

module.exports = findInmatesSchema;
